import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "C Box Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */

@Component({
    selector: 'app-icon-c-box-outline',
    templateUrl: './icon-c-box-outline.component.html',
    styleUrls: ['./icon-c-box-outline.component.scss'],
    standalone: false
})
export class IconCBoxOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
